import { Box } from '@mui/material';
import { Chip } from '../../chip';
import { Selected } from '../props';

type Props = {
  arr: Array<Selected>;
  removeChips: (label?: string) => void;
};

export const FilterChips = ({ arr, removeChips }: Props) => {
  return arr.length ? (
    <Box
      display="flex"
      alignItems="flex-start"
      flexWrap="wrap"
      flexDirection="column"
      width="100%"
    >
      {arr.map((item: Selected, index) => (
        <Box key={index} mb={1} width="100%" textAlign="left">
          <Chip
            label={item.value}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              e.stopPropagation();
              removeChips(item.value);
            }}
          />
        </Box>
      ))}
    </Box>
  ) : null;
};
